import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSuffix } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SfoUiJSONSchema7 } from '../../../../metadata.model';

@Component({
  selector: 'sfo-textarea',
  templateUrl: './textarea.component.html',
  imports: [
    MatFormFieldModule,
    MatTooltipModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSuffix,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class TextareaInputComponent implements OnInit {
  @Input() schema!: SfoUiJSONSchema7;
  @Input() aFormControl!: FormControl;
  @Input() defaultValue: unknown;

  placeholder: string;

  ngOnInit(): void {
    this.placeholder =
      typeof this.defaultValue === 'string'
        ? this.defaultValue
        : typeof this.schema?.default === 'string'
          ? this.schema.default
          : 'Enter text here';
  }

  resetToDefault() {
    this.aFormControl.markAsDirty();
    if (this.schema && this.aFormControl) {
      this.aFormControl.setValue(this.defaultValue || this.schema.default);
    }
  }
}
